import { useQueries } from '@tanstack/react-query'
import { useDataProvider } from 'react-admin'

const BATCH_SIZE = 50

const useBatchedGetMany = (resource, ids, { enabled = true, search = '' } = {}) => {
  const dataProvider = useDataProvider()
  const searchTerm = search.trim()
  const batches = []
  for (let index = 0; index < ids.length; index += BATCH_SIZE) {
    batches.push(ids.slice(index, index + BATCH_SIZE))
  }

  const results = useQueries({
    queries: batches.map((batch) => ({
      queryKey: searchTerm
        ? [
            resource,
            'getList',
            {
              pagination: { page: 1, perPage: BATCH_SIZE },
              sort: { field: 'id', order: 'ASC' },
              filter: { id: batch.map(String), search_designation: searchTerm },
            },
          ]
        : [resource, 'getMany', { ids: batch.map(String) }],
      queryFn: ({ signal }) => {
        const request = searchTerm
          ? dataProvider.getList(resource, {
              pagination: { page: 1, perPage: BATCH_SIZE },
              sort: { field: 'id', order: 'ASC' },
              filter: { id: batch, search_designation: searchTerm },
              signal: dataProvider.supportAbortSignal ? signal : undefined,
            })
          : dataProvider.getMany(resource, {
              ids: batch,
              signal: dataProvider.supportAbortSignal ? signal : undefined,
            })
        return request.then(({ data }) => data)
      },
      enabled,
      retry: false,
    })),
  })

  return {
    data: results.flatMap(({ data }) => data || []),
    isPending: results.some(({ isPending }) => isPending),
    error: results.find(({ error }) => error)?.error ?? null,
  }
}

export default useBatchedGetMany
